module.exports = __webpack_public_path__ + "img/antes_despues_254.92e4a4bf.png";